module.exports = __webpack_public_path__ + "img/cpanel.5199067c.svg";